import request from "@utils/request";
import qs from "qs";

/*
 * 商品分类
 * */
export function getCategory() {
  return request.get("/wap/category", {}, { login: false });
}

/*
 * 商品详情
 * */
export function getProductDetail(id) {
  return request.get("/wap/goods/detail/" + id, {}, { login: false });
}

/*
 * 商品分销二维码
 * */
export function getProductCode(id) {
  return request.get("/wap/goods/code/" + id, {}, { login: true });
}

/*
 * 商品列表
 * */
export function getProducts(q) {
  return request.get("/wap/products", q, { login: false });
}

/*
 * 购物车数量
 * */
export function getCartNum() {
  return request.get("/cart/count");
}

/*
 * 添加收藏
 * */
export function toCollect(id, category) {
  return request.get("/collect/add/" + id + "/" + category);
}

/*
 * 热门产品
 * */
export function getHostProducts(page, limit) {
  return request.get(
    "/wap/product/hot",
    { page: page, limit: limit },
    { login: false }
  );
}

/*
 * 精品推荐
 * */
export function getBastProducts(page, limit) {
  return request.get(
    "/wap/product/bast",
    { page: page, limit: limit },
    { login: false }
  );
}

/*
 * 精品、热门、首发列表
 * */
export function getGroomList(type) {
  return request.get("/wap/groom/list/" + type, {}, { login: false });
}

/*
 * 购物车 添加
 * */
export function postCartAdd(data) {
  return request.post("/wap/cart/add", data);
}

/*
 * 购物车列表
 * */
export function getCartList() {
  return request.get("/wap/cart/list");
}

/*
 * 购物车 删除
 * */
export function postCartDel(ids) {
  // return request.post("/wap/cart/del", qs.stringify(ids, { arrayFormat: 'repeat' }));
  return request.post("/wap/cart/del", Object.values(ids));
}

/*
 * 购物车 获取数量
 * */
export function getCartCount(data) {
  return request.get("/wap/cart/count", data);
}

/*
 * 购物车 修改商品数量
 * */
export function changeCartNum(id, number) {
  return request.post("/wap/cart/num", { id, num: number });
}

/**
 * 搜索推荐关键字
 */
export function getSearchKeyword() {
  return request.get("/wap/search/keyword", {}, { login: false });
}

/**
 * 产品评论列表
 */
export function getReplyList(id, q) {
  return request.get("/wap/reply/list/" + id, q, { login: false });
}

/**
 * 产品评价数量和好评度
 */
export function getReplyConfig(id) {
  return request.get("/wap/reply/config/" + id, {}, { login: false });
}

/**
 * 产品评价
 */
export function getProductReply(id) {
  return request.get("/wap/product/reply/" + id, {}, { login: false });
}

/**
 * 评价页面获取单个产品详情
 */
export function postOrderProduct(orderId, productId) {
  return request.post(
    "/wap/order/product",
    qs.stringify({ orderId, productId }),
    { login: false }
  );
}

/**
 * 提交评价页面；
 */
export function postOrderComment(data) {
  return request.post("/wap/order/comment", data);
}
